kdx-dropdown-list {
    display: flex;
    position: relative;

    //Wrapper for the custom select
    .kdx-dropdown-list {
        position: absolute;
        top: calc(50%);
        left: 0;
        right: 0;
        transform: translateY(-50%);
        display: none; // hide by default, mouse check will display

        &.show {        
            z-index: 1;
        }
    }

    //Styles for both the native select and custom select
    .dropdown-select {
        background-color: white;
        border: none;
        border-radius: 5px;
        color: black;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        display: inline-flex;
        height: 100%;
        max-height: 2.75rem;
        min-width:  7.5rem;
        padding-block:  0.5rem;
        padding-inline: 1rem 5.5rem;
        position: relative;
        text-align: left;
        text-decoration: none;
        width: 100%;
        font-weight: 700;

        //Hide native select arrow
        -webkit-appearance: none;
           -moz-appearance: none;
                appearance: none;
        
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;


        option {
            //Customize native option styles
            width: 100%;
        }

        &:hover, &:focus {
            color: currentColor;
        }

        //Icon sizing for the native select and custom select
        + .svg-icon, .svg-icon {
            svg {
                @include svg-format(12px, 12px, $secondary);
                // color: currentColor;
                // max-height: 0.75rem;
                // max-width:  0.75rem;
                // min-width:  0.75rem;
                // width: 100%;
                @include svg-format(14px, 16px, $primary);
                transform: rotate(0);
                transition: transform ease-in-out 0.125s;
            }
        }

        //Spacing adjustments for the native select icon
        + .svg-icon {
            position: absolute;
            top: calc(0.375rem + 1px);
            right:   calc(1rem + 1px);
        }

        //Spacing adjustments for the custom select icon
        .svg-icon {
            position: absolute;
            margin-top: -1px;
            right: 1rem;

            &:is(button) {
                background-color: transparent;
                border: none;
                padding: 0;
            }
        }
    }

    //The options list for the custom select
    .dropdownmenu {
        background-color: white;
        border: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16); 
        display: none;
        max-height: 40vh;
        max-width: 100%;
        overflow-y: auto;
        padding: 0.625rem 0;
        position: absolute;
        top: 100%;
        width: 100%;

        &.show {
            display: block;
        }

        .dropdown-item {
            cursor: default;
            overflow: hidden;
            padding-block: calc(0.375rem - 1px) 0.375rem;
            padding-inline: 1rem;
            white-space: normal;
            text-overflow: ellipsis;
            
            &.hidden {
                display: none;
            }
            
            &:hover,
            &:focus {
                background-color: #EDEDED;
                color: $quinary;
            }
        }
    }

    //The placeholder in the custom select
    .dropdown-text {
        color: currentColor;
        font-weight: 700;
    }

    &.homepage-pageselector {

        .kdx-dropdown-list { 
            border-bottom: 1px solid #000000;
            
            .dropdown-select {
                .svg-icon {
                    right: 0.5rem;
                }
            }
        }

        .dropdown-select {
            box-shadow: none;
            max-width: 100%;
            padding-inline: 0;
            padding-block: 0;
            border-radius: 0;
            border: none;
            border-bottom: 1px solid #000000;

            +.svg-icon { 
                right: 0; 
                top: 0;
            }

            .dropdown-item {
                width: 100%;
            }
        }

        @include media-breakpoint-down(md) {
            .dropdown-select {
                padding-block: 0;
                border-bottom: 1px solid #000000;
            }
        }
    }
}

/* Styles for mouse/stylus users only */
@media (hover: hover) {
    kdx-dropdown-list {
        .kdx-dropdown-list {
            display: block;
        }
    
        /* Show native select if keyboard controls */
        select:focus ~ .kdx-dropdown-list {
            display: none;
        }
    }
}

@include media-breakpoint-down(lg) {
    kdx-dropdown-list {
        .dropdown-select {
            max-width: 100%;
        }
    }
} 